var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1f2923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4.50009C9.5 4.22395 9.72386 4.00009 10 4.00009C10.2761 4.00009 10.5 4.22395 10.5 4.50009V14.2859L13.4393 11.3465C13.6346 11.1513 13.9512 11.1513 14.1464 11.3465C14.3417 11.5418 14.3417 11.8584 14.1464 12.0536L10.4002 15.7999C10.3716 15.8379 10.3378 15.8717 10.2999 15.9002L10.2574 15.9427C10.2544 15.9398 10.2516 15.9369 10.2487 15.934C10.1754 15.976 10.0905 16.0001 10 16.0001C9.90947 16.0001 9.82456 15.976 9.75131 15.934L9.74264 15.9427L9.70015 15.9002C9.66216 15.8717 9.62837 15.8379 9.59986 15.7999L5.85355 12.0536C5.65829 11.8584 5.65829 11.5418 5.85355 11.3465C6.04882 11.1513 6.3654 11.1513 6.56066 11.3465L9.5 14.2859V4.50009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrowDown.d7ff96049137554b705834a3b50de83e.svg";
export { ForwardRef as ReactComponent };